import api from './client'
import type { CrmNotification } from '../api'

export const notificationApi = {
  unreadCount: async (): Promise<{ count: number }> => {
    const response = await api.get<{ count: number }>('/notifications/unread-count')
    return response.data
  },

  list: async (): Promise<{ notifications: CrmNotification[] }> => {
    const response = await api.get<{ notifications: CrmNotification[] }>('/notifications')
    return response.data
  },

  markAllRead: async (): Promise<void> => {
    await api.post('/notifications/mark-all-read')
  },
}
